<template>
  <div class="container">
    <CommonFrame :workNo="workNo"
                  :btns="btns"
                  :node="node"
                  :moduleName="moduleName"
                  :breadcrumb="breadcrumb"
                  @btnClick='handleClick'
                  :endStatus="approvalParams.endStatus"
                  :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="info">
        <h4>
          <span>召回单号:</span>
          <span>{{id}}</span>
        </h4>
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="formInfo">
        <lk-form label-position="right"
                 :label-width="130">
          <div class="cardContainer">
            <lk-card title="召回计划信息">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="召回机构:">
                    <span>{{recallForm.saleRecallPlan.recallAgency}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>

              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="召回原因:">
                    <span>{{recallForm.saleRecallPlan.recallReason}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>

              <lk-row :gutter="16">
                 <lk-col span="10">
                   <lk-form-item label="召回凭据:">
                      <Uploader style="width:250px" :able='false' v-model="recallForm.saleRecallPlan.recallImgUrl"></Uploader>
                  </lk-form-item>
                 </lk-col>
              </lk-row>

              <lk-row :gutter="16">
                <lk-col>
                  <lk-form-item label="召回商品:">
                    <div class="goodsTable">
                      <lk-table border :columns='columns' :data='tableData'></lk-table>
                    </div>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </CommonFrame>
    <lk-modal v-model="showLog" title="操作日志" footer-hide>
      <div class="records">

        <div class="record" v-for="(item,index) in recordlist" :key='index'  >
          {{item}}
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import axios from 'axios';
import utils from '@/libs/utils';
import afterSale from '@/services/afterSale';
import CommonFrame from '../commonFrame.vue';
import Uploader from '../../../components/Uploader.vue'

export default {
  name: 'SaleRecallPlan',
  data() {
    return {
      columns: [
        {
          title: '序号', key: 'index', width: 80, type: 'index',
        },
        {
          title: '单据来源',
          key: 'revokedTypeEnum',
          minWidth: 116,
          render: (h, params) => {
            if (params.row.revokedTypeEnum === 1) {
              return h('span', '库存商品');
            } if (params.row.revokedTypeEnum === 2) {
              return h('span', '销售订单');
            } if (params.row.revokedTypeEnum === 3) {
              return h('span', '调拨单');
            }
            return h('span', '-');
          },
        },
        { title: '单号', key: 'itemId', minWidth: 116 },
        { title: '商品名称', key: 'drugApprovedNames', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '数量', key: 'itemCount', minWidth: 116 },
      ],
      tableData: [],
      recallForm: {
        saleRecallPlan: {
          id: '', // 召回计划id
          recallReason: '', // 召回原因
          recallAgency: '', // 召回机构
          drugApprovedNames: '', // 商品名称
          recallImgUrl: '', //召回凭据
          drugSerialCode: '', // 商品编码
          specifications: '', // 规格
          licenseNumber: '', // 批准文号
          manufacturer: '', // 生产企业
          supplierStoreId: '', // 供应商id
        },
        saleRecallPlanInfoVOS: [],
      },
      breadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '药品召回审批',
        },
      ],
      btns: [
        {
          name: 'log',
          text: '操作日志',
          type: 'default',
        },
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
      id: '',
      showLog: false,
      logData: [],
      logPage: 1,
      logSize: 10,
      logCount: 0,
      logParams: {
        recallPlanId: '',
      },
    };
  },
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
    Uploader
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getInfo(this.approvalParams.businessUrl);
  },
  methods: {
    handleClick(text) {
      console.log(text);

      if (text === 'log') {
        this.getRecord();
        this.showLog = true;
      }
    },
    getRecord() {
      this.logParams.page = this.logPage;
      this.logParams.size = this.logSize;
      this.logParams.recallPlanId = this.tableData[0].recallPlanId;
      const params = Object.assign({}, this.logParams);
      afterSale.recallOperateLog(params).then((res) => {
        if (res.data.status === 200) {
          this.logData = [];
          res.data.data.list.forEach((item) => {
            this.logData.push({
              time: utils.exchangeTimeToSecond(item.saleRecallPlanModifiedHistory.createTime),
              name: item.saleRecallPlanModifiedHistory.createUserName,
              content: item.saleRecallPlanModifiedHistory.content,
            });
          });
          // this.logData = res.data.data.list;
          console.log(this.logData);
        }
      });
    },
    getInfo(businessUrl) {
      axios.post(businessUrl).then((res) => {
        if (res.data.status === 200) {
          const temp = Object.assign({}, res.data.data);

          this.id = temp.saleRecallPlan.recallPlanCode;
          this.infosArr.push(
            { name: '召回门店', value: temp.saleRecallPlan.storeName },
            { name: '召回时间', value: utils.exchangeTimeToSecond(temp.saleRecallPlan.modifiedTime) },
            { name: '召回人', value: temp.saleRecallPlan.createUserName },
          );

          this.recallPlanStatus = temp.saleRecallPlan.recallPlanStatus; // 召回状态
          this.recallForm.saleRecallPlan = {
            id: temp.saleRecallPlan.id, // 召回计划id
            recallReason: temp.saleRecallPlan.recallReason, // 召回原因
            recallAgency: temp.saleRecallPlan.recallAgency, // 召回机构
            recallImgUrl: temp.saleRecallPlan.recallImgUrl, //召回凭据
            drugApprovedNames: temp.saleRecallPlan.drugApprovedNames, // 商品名称
            drugSerialCode: temp.saleRecallPlan.drugSerialCode, // 商品编码
            specifications: temp.saleRecallPlan.specifications, // 规格
            licenseNumber: temp.saleRecallPlan.licenseNumber, // 批准文号
            manufacturer: temp.saleRecallPlan.manufacturer, // 生产企业
            supplierStoreId: temp.saleRecallPlan.supplierStoreId, // 供应商id
          };
          this.recallForm.saleRecallPlanInfoVOS = temp.saleRecallPlanInfoVOS;

          if (temp.saleRecallPlanInfoVOS && temp.saleRecallPlanInfoVOS.length > 0) {
            temp.saleRecallPlanInfoVOS.forEach((item) => {
              this.tableData.push({
                drugApprovedNames: temp.saleRecallPlan.drugApprovedNames,
                goodsBatchNumber: temp.saleRecallPlan.licenseNumber,
                itemCount: item.saleRecallPlanInfo.revokingCount,
                itemId: item.saleRecallPlanInfo.recallItemId,
                manufacturer: temp.saleRecallPlan.manufacturer,
                revokedTypeEnum: item.saleRecallPlanInfo.revokedType,
                specifications: temp.saleRecallPlan.specifications,
                recallPlanId: item.saleRecallPlanInfo.recallPlanId,
              });
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  computed: {
    recordlist() {
      const result = [];
      this.logData.forEach((el, index) => {
        let str = `${index + 1}.${el.time}, 由 ${el.name}${el.content} 。`;
        if (el.newValue && el.oldValue) {
          str += `修改了 是否医保点，旧值：${el.oldValue}，新值：${el.newValue}.`;
        }
        result.push(str);
        // 1.2019/01/14 12:24:30, 由 张三 创建。
      });
      return result;
    },
  },
};
</script>

<style scoped>

</style>
